import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Route } from '@bca-shared/models/_enums';

@Component({
  selector: 'bca-tab',
  template: `
    <div *ngIf="active">
    	<ng-content></ng-content>
    </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabComponent {
  @Input()
  title: string;
  @Input()
  route: Route;
  @Input()
  active: boolean;
  @Input()
  done: boolean;
}
